import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pois as poisApi, poiCategories as catApi } from '@/lib/trackizy';
import { poisActions } from '@/store';

export default function usePOIs() {
  const dispatch = useDispatch();
  const orgId = useSelector((state) => state.org?.id);
  const userId = useSelector((state) => state.session.user?.id);

  useEffect(() => {
    // Skip fetching until authenticated — avoids 401 noise on login page
    if (!userId) return;

    poisApi.list()
      .then((data) => {
        if (Array.isArray(data)) dispatch(poisActions.refresh(data));
      })
      .catch((err) => console.error('Failed to fetch POIs:', err));

    catApi.list()
      .then((data) => {
        if (Array.isArray(data)) dispatch(poisActions.refreshCategories(data));
      })
      .catch((err) => console.error('Failed to fetch POI categories:', err));
  }, [dispatch, orgId, userId]);
}
